import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useTheme,
} from '@mui/material';

export type GenerateReportDialogProps = {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  text?: string;
};

function ResetToDefaultsDialog({
  open,
  onClose,
  onSuccess,
  text,
}: GenerateReportDialogProps) {
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: { borderRadius: '10px', padding: '16px', width: '500px' },
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        style={{
          verticalAlign: 'left',
          display: 'flex',
          color: theme.palette.error.main,
        }}
      >
        <p
          style={{
            margin: 0,
            alignSelf: 'self-end',
            fontSize: '28px',
            fontWeight: 700,
          }}
        >
          Reset to defaults
        </p>
      </DialogTitle>

      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          sx={{ color: '#525F81', fontWeight: 400 }}
        >
          <p>This will set the data to the default recommended values.</p>

          <p>Proceed?</p>
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ gap: '1rem' }}>
        <Button
          onClick={onClose}
          size="large"
          variant="text"
          style={{
            backgroundColor: '#0000330F',
            width: '100px',
            borderRadius: 5,
            color: '#60646C',
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            onSuccess();
            onClose();
          }}
          variant="contained"
          // color="primary"
          size="large"
          style={{
            backgroundColor: '#E5484D',
            width: '100px',
            borderRadius: 5,
          }}
        >
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ResetToDefaultsDialog;
